module.exports = __webpack_public_path__ + "static/media/foto-cuerpo.c88268d5.jpg";